module.exports = __webpack_public_path__ + "img/no-result-found.b8e91912.svg";